import Content from '@common/content';
import LoginModal from '@components/loginModal';
import { useUserInfo } from '@repository/auth/useUserInfo';
import { useCheckInProgress } from '@repository/interviewPractices/useInterviewPractices';
import useCheckAuthority from '@utils/hooks/useCheckAuthority';
import useIO from '@utils/hooks/useIO';
import { ContentRouteUrl, ContentRouteUtil } from '@utils/routeUtil';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import AllianceList from './allianceList';
import InterviewPracticeGateBanner from './banner';
import Faq from './faq';
import LastBanner from './lastBanner';
import InterviewPracticeList from './list';
import InterviewPracticeModeModal from './modeModal';

const InterviewPracticeGate = () => {
  const { data: userData } = useUserInfo();
  const isLogin = !!userData?.id;
  const { isAuthorityUser } = useCheckAuthority(userData);
  const { data: progressInfo } = useCheckInProgress(isAuthorityUser);

  const [redirectUrl, setRedirectUrl] = useState<string>(ContentRouteUrl.PASS_INTERVIEW);
  const [loginModalVisible, setLoginModalVisible] = useState(false);
  const [modeModalVisible, setModeModalVisible] = useState(false);
  const [fadeInFirst, setFadeInFirst] = useState<boolean>(false);
  const [fadeInSecond, setFadeInSecond] = useState<boolean>(false);

  const { query } = useRouter();

  //면접 연습하러 가기 클릭 이벤트
  const onClickPracticeBtn = async () => {
    if (!isLogin) {
      setRedirectUrl(`${ContentRouteUrl.PASS_INTERVIEW}?open=mode`);
      setLoginModalVisible(true);
      return;
    }

    if (progressInfo?.inProgress) {
      setModeModalVisible(true);
    } else {
      ContentRouteUtil.goInterviewStart();
    }
  };

  //면접 기록 확인하러가기 클릭 이벤트
  const onClickHistoryClick = () => {
    if (!isLogin) {
      setLoginModalVisible(true);
      return;
    }

    if (!isAuthorityUser) return ContentRouteUtil.goInterviewStart();

    ContentRouteUtil.goInterviewHistory();
  };

  useEffect(() => {
    if (query.open && isLogin) {
      setLoginModalVisible(false);

      switch (query.open) {
        case 'mode':
          onClickPracticeBtn();
          break;
        case 'history':
          onClickHistoryClick();
          break;
      }

      ContentRouteUtil.goInterview(true);
    }
  }, [query.open, isLogin]);

  // Intersection Observer
  const handleIntersectFirst = (entries: IntersectionObserverEntry[]) => {
    if (entries[0].isIntersecting) {
      setFadeInFirst(true);
    }
  };
  const handleIntersectSecond = (entries: IntersectionObserverEntry[]) => {
    if (entries[0].isIntersecting) {
      setFadeInSecond(true);
    }
  };

  const setFirstSectionRef = useIO({ onIntersect: handleIntersectFirst, threshold: 0.5 });
  const setSecondSectionRef = useIO({ onIntersect: handleIntersectSecond, threshold: 0.5 });

  return (
    <Content>
      <div>
        <InterviewPracticeGateBanner onPracticeClick={onClickPracticeBtn} onHistoryClick={onClickHistoryClick} />
        <InterviewPracticeList
          setFirstSectionRef={setFirstSectionRef}
          setSecondSectionRef={setSecondSectionRef}
          fadeInFirst={fadeInFirst}
          fadeInSecond={fadeInSecond}
        />
        <AllianceList />
        <Faq />
        <LastBanner onPracticeClick={onClickPracticeBtn} />
      </div>
      <InterviewPracticeModeModal
        visible={modeModalVisible}
        onClose={() => setModeModalVisible(false)}
        progressInfo={progressInfo}
      />
      <LoginModal
        subTitle="채용정보 · 역량검사 · 매칭까지"
        title="취업기회 지금 바로 잡다!"
        visible={loginModalVisible}
        onClose={() => setLoginModalVisible(false)}
        redirectUrl={redirectUrl}
      />
    </Content>
  );
};

export default InterviewPracticeGate;
